<template>
  <div class="cropper-tc relativeItem" @touchmove.prevent>
    <div class="upload-demo absoluteItem" v-show="show_up_demo">
      <div class="d1">
        <p class="p1">{{ title }}</p>
        <p class="p2">支持绝大多数图片格式，单张图片最大支持2MB</p>
        <p class="p3" @click="choose_img" :class="{ clicked: clicked_btn }">选择图片</p>
      </div>
      <div class="d2" @click="dialogVisible" :class="{ clicked: clicked_btn }">取消</div>

      <input type="file" id="file-input" @change="changeUpload" />
    </div>

    <div class="cropper-content" v-show="!show_up_demo">
      <div class="cropper" style="text-align: center">
        <vueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.size"
          :outputType="option.outputType"
          :info="true"
          :full="option.full"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :autoCrop="option.autoCrop"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :centerBox="option.centerBox"
          :infoTrue="option.infoTrue"
          :fixedBox="option.fixedBox"
        ></vueCropper>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" v-if="!show_up_demo">
      <button @click="dialogVisible">取 消</button>
      <button type="primary" @click="finish">确认</button>
    </div>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";

export default {
  name: "CropperImage",
  components: {
    VueCropper,
  },
  props: ["img_item_id", "title", "fixedNumber"],
  data() {
    return {
      previews: {},
      option: {
        img: "", //裁剪图片的地址
        outputSize: 0.7, //裁剪生成图片的质量(可选0.1 - 1)
        outputType: "jpeg", //裁剪生成图片的格式（jpeg || png || webp）
        info: true, //图片大小信息
        canScale: true, //图片是否允许滚轮缩放
        autoCrop: true, //是否默认生成截图框
        fixed: true, //是否开启截图框宽高固定比例
        // fixedNumber: [1.55, 1], //截图框的宽高比例
        fixedNumber: this.fixedNumber, //截图框的宽高比例
        full: false, //false按原比例裁切图片，不失真
        fixedBox: false, //固定截图框大小，不允许改变
        canMove: false, //上传图片是否可以移动
        canMoveBox: true, //截图框能否拖动
        original: false, //上传图片按照原始比例渲染
        centerBox: false, //截图框是否被限制在图片里面
        height: true, //是否按照设备的dpr 输出等比例图片
        infoTrue: false, //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 2000, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "100%", //图片默认渲染方式
      },
      show_up_demo: true, //是否显示上传框
      clicked_btn: false, //是否点击按钮 增加点击样式
    };
  },
  methods: {
    //取消裁剪 关闭cropper组件弹窗
    dialogVisible() {
      let _this = this;
      this.clicked_btn = true;
      setTimeout(() => {
        _this.clicked_btn = false;
      }, 300);
      this.show_up_demo = true;
      this.option.img = "";
      document.querySelector("#file-input").value = "";
      this.$emit("close_cropper");
    },

    //打开input
    choose_img() {
      let _this = this;
      this.clicked_btn = true;
      setTimeout(() => {
        _this.clicked_btn = false;
      }, 300);
      let input = document.querySelector("#file-input");
      input.click();
    },

    // 上传按钮   限制图片大小
    changeUpload(e) {
      let _this = this,
        fr = new FileReader(),
        img_obj = e.target.files[0],
        filePath = e.target.value;
      const isLt5M = img_obj.size / 1024 / 1024 < 2;
      if (!isLt5M) {
        this.$tool.tip("上传文件大小不能超过 2MB!", "50%");
        return false;
      }
      if (
        filePath.indexOf("jpg") != -1 ||
        filePath.indexOf("JPG") != -1 ||
        filePath.indexOf("PNG") != -1 ||
        filePath.indexOf("png") != -1 ||
        filePath.indexOf("jpeg") != -1 ||
        filePath.indexOf("JPEG") != -1
      ) {
        fr.readAsDataURL(img_obj);
        fr.onload = function (res) {
          _this.option.img = res.target.result;
          _this.show_up_demo = false;
        };
      } else {
        _this.$tool.tip("上传文件类型有误,请上传图片", "50%");
      }
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let _this = this;
      this.$refs.cropper.getCropBlob((res) => {
        let data = {
          name: _this.img_item_id,
          obj: res,
        };
        _this.$emit("uploadImgSuccess", data);
        _this.dialogVisible();
      });
    },
  },
  mounted: function () {},
};
</script>

<style scoped>
.cropper-tc {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 19;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
}
.upload-demo {
  padding: 0 10px;
  width: 100%;
  text-align: center;
  bottom: 0;
  left: 0;
  animation: show 0.4s;
  -webkit-animation: show 0.4s;
  /* Safari 和 Chrome */
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.upload-demo > div {
  border-radius: 4px;
  background: #fff;
  text-align: center;
  padding: 0 5px;
}
.upload-demo .p1 {
  font-size: 14px;
  color: #666;
  padding-top: 16px;
}
.upload-demo .p2 {
  font-size: 12px;
  color: #999;
  padding-bottom: 16px;
  border-bottom: 1px solid #f4f4f4;
}
.upload-demo .p3 {
  font-size: 16px;
  color: #5c61f1;
  padding: 11px 0;
}
.upload-demo .d2 {
  font-size: 16px;
  color: #666;
  padding: 10px 0;
  margin: 10px 0 20px 0;
}
.upload-demo input {
  visibility: hidden;
}
.upload-demo .clicked {
  background: #f4f4f4;
}

.cropper-content .cropper {
  width: auto;
  height: 100vh;
}

.dialog-footer {
  position: absolute;
  z-index: 5;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px;
  background: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dialog-footer button {
  padding: 3px 15px;
  background: none;
  font-size: 16px;
  color: #fff;
}
</style>
